import * as z from 'zod';

import { booleanMutationSchema, nullableNumericMutationSchema } from '@/_schemas/generic';

import { agreementQuerySchema } from './agreements-query-schema';
import { subsidyMutationSchema } from './subsidy-schemas';

import { agreementInstallmentsCreateSchema } from '../installments/schemas/agreement-installments-mutation-schema';

export const agreementUpdateSchema = agreementQuerySchema
  .omit({
    client: true,
    primary_domains: true,
    account_manager: true,
    agreement_deliverables: true,
    opt_in: true,
    one_time_total: true,
    opt_in_total: true,
    monthly_recurring_total: true,
    annual_recurring_total: true,
    billing_term: true,
    terms_condition_template: true,
    agreement_signer: true,
    brand: true,
    partner: true,
    agreement_installments: true,
    exclude_from_averages: true,
    agreement_commissions: true,
  })
  .extend({
    client_id: z.number(),
    account_manager: z.array(z.object({ id: z.number(), sort_order: z.number() })),
    primary_domains: z.array(z.number()).nullable(),
    agreement_deliverables: z.array(z.number()),
    agreement_contact: z.array(z.number()).nullable(),
    project_contact: z.array(z.number()).nullable(),
    billing_contact: z.array(z.number()).nullable(),
    emergency_contact: z.array(z.number()),
    billing_email_contacts: z.array(z.number()),
    harvest: nullableNumericMutationSchema(),
    agreement_draft: z.array(z.number()).nullable(),
    fully_executed_agreement: z.array(z.number()).nullable(),
    agreement_installments: z.array(agreementInstallmentsCreateSchema),
    wholesale_price_enabled: booleanMutationSchema(),
    addresses: z.array(z.number()),
    exclude_from_averages: booleanMutationSchema(),
    enable_commission: booleanMutationSchema(),

    subsidies: z.array(subsidyMutationSchema).nullish(),

    orphan_invoicing: booleanMutationSchema(),

    /**
     * Optional PIN to override a revenue lockdown period.
     * Backend will ignore/log separately and won't return it in responses.
     */
    lockdown_override_pin: z.string().optional(),
    override_justification_note: z.string().optional(),
  });

export type AgreementUpdateSchema = z.infer<typeof agreementUpdateSchema>;

export const agreementsCreateSchema = agreementUpdateSchema
  .pick({
    agreement_date: true,
    expiry_date: true,
    client_id: true,
    pipeline: true,
    primary_domains: true,
    account_manager: true,
    agreement_id: true,
    billing_term_id: true,
    status: true,
    brand_id: true,
    partner_id: true,
    agreement_installments: true,
    addresses: true,
    parent_id: true,
  })
  .extend({
    agreement_installments: z.array(agreementInstallmentsCreateSchema),
  });

export type AgreementsCreateSchema = z.infer<typeof agreementsCreateSchema>;
